var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('el-carousel',{attrs:{"height":"520px","interval":5000,"arrow":"always","trigger":"click"}},_vm._l((_vm.bannerList),function(item){return _c('el-carousel-item',{key:item.id},[_c('img',{staticClass:"banner-img",attrs:{"src":item.img,"alt":"banner"}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }